import React from 'react'
import { WithFlashMessages } from '../../flashmessages/FlashMessageProvider'
import { WithSession } from '../../session/SessionProvider'
import I18n from 'i18n'
import { WithBackend } from '../../backend/BackendProvider'
import { locationParam } from '../../common/Utils'
import TextField from '../../atomic/atoms/TextField'

class Confirmation extends React.Component {
  constructor (props) {
    super(props)
    const token = locationParam(props.location, 'confirmation_token')
    this.state = {
      message: I18n.t(token ? 'flashmessages.confirmation.prompt' : 'flashmessages.confirmation.resend.prompt'),
      processing: false,
      showResend: !token,
      email: '',
      resendSent: false
    }
    this.handleConfirm = this.handleConfirm.bind(this)
    this.handleResend = this.handleResend.bind(this)
  }

  componentDidMount () {
    this.props.updateSession({ sessionToken: '' })
    this.props.setHeight(this.state.showResend ? 300 : 150)
  }

  handleConfirm (e) {
    e.preventDefault()
    this.setState({ message: I18n.t('flashmessages.confirmation.processing'), processing: true })
    this.props.backend.confirm(locationParam(this.props.location, 'confirmation_token')).then((success) => {
      this.redirectToLogin('flashmessages.confirmation.successful', success.data.redirect_uri)
    }).catch((err) => {
      const data = err.response?.data
      if (err.response?.status === 422 && data?.already_confirmed) {
        this.redirectToLogin('flashmessages.confirmation.already_confirmed', data.redirect_uri)
        return
      }
      console.log('An error occurent when activating your account:')
      console.log(err)
      this.setState({ message: I18n.t('flashmessages.confirmation.failed'), processing: false, showResend: true })
      this.props.setHeight(300)
    })
  }

  handleResend (e) {
    e.preventDefault()
    this.setState({ processing: true })
    this.props.backend.resendConfirmation(this.state.email).catch((err) => {
      console.log(err)
    }).finally(() => {
      this.setState({ message: I18n.t('flashmessages.confirmation.resend.sent'), processing: false, resendSent: true })
    })
  }

  redirectToLogin (messageKey, redirectUri) {
    this.props.flashMessages.push(
      I18n.t(messageKey),
      this.props.flashMessages.duration.SHORT,
      this.props.flashMessages.levels.INFO)
    // Redirected to login page to prevent auto-redirect to info page
    this.props.history.push(redirectUri ? `/login?redirect_uri=${encodeURIComponent(redirectUri)}` : '/login')
  }

  renderResendForm () {
    const { email, processing } = this.state
    return (
      <form onSubmit={this.handleResend}>
        <div className='row'>
          <div className='col s12'>
            <TextField
              name='resend-confirmation-email'
              type='email'
              label={I18n.t('flashmessages.confirmation.resend.email')}
              value={email}
              onChange={(e) => this.setState({ email: e.target.value })}
            />
          </div>
        </div>
        <div className='row'>
          <div className='col s12'>
            <button
              id='resend-confirmation-button'
              type='submit'
              disabled={processing || !email}
              className='waves-effect waves-light text-primary-color background-primary button-primary text-background-color button-autowidth'
            >
              {I18n.t('flashmessages.confirmation.resend.button')}
            </button>
          </div>
        </div>
      </form>
    )
  }

  render () {
    const { message, processing, showResend, resendSent } = this.state
    return (
      <>
        <div className='row'>
          <div className='col s12'>
            <span id='confirmation-message'>{message}</span>
          </div>
        </div>
        {showResend && !resendSent && this.renderResendForm()}
        {!showResend && (
          <div className='row'>
            <div className='col s12'>
              <button
                id='confirm-email-button'
                onClick={this.handleConfirm}
                disabled={processing}
                className='waves-effect waves-light text-primary-color background-primary button-primary text-background-color button-autowidth'
              >
                {I18n.t('flashmessages.confirmation.button')}
              </button>
            </div>
          </div>
        )}
      </>
    )
  }
}

export default WithBackend(WithFlashMessages(WithSession(Confirmation)))
